import { PAGE_SIZE, ORIGIN_VALUES } from '@/components/Developments/constants';

const initialState = {
  filtersData: {
    types: [],
    locations: [],
    constructionsStatus: [],
    status: [],
    deliveryDate: [],
  },
  filtersSelections: {
    types: null,
    locations: null,
    constructionsStatus: null,
    status: [],
    deliveryDate: {
      min: { year: null, month: null },
      max: { year: null, month: null },
    },
    origin: [{ id: ORIGIN_VALUES.TOKKO }],
  },
  companyActiveIntegrations: [],
  searcherText: '',
  developments: [],
  loading: true,
  paginator: {
    hasNext: false,
    numPages: 1,
    perPage: PAGE_SIZE,
    total: 0,
    page: 1,
    previous: null,
  },
  isInitialized: false,
  listingEditionReviewCounts: null,
  listingEditionReviewSelection: [],
  controlListingEditionCounts: null,
};

export default initialState;
